module.exports = __webpack_public_path__ + "static/squiggle-right-fc26d7186b8ff77f22df36eeb8c6156b.png";